/*
 * @Descripttion: 
 * @Author: voanit
 * @Date: 2022-01-18 11:37:55
 * @LastEditors: voanit
 * @LastEditTime: 2022-01-23 15:36:48
 */
import store from '@/store'
import { getMessageList, getUnreadTotal } from '@/server/message'
import SockJS from '@/utils/sockjs.min.js'
import Stomp from 'stompjs'
import Cookies from 'js-cookie'
import { _local } from '@/utils/storage'

store.registerModule('headerMessage', {
  state: {
    messageList: [],
    unread: 0,
  },
  mutations: {},
  actions: {
    async getMessageList(store, params = {}) {
      const { data } = await getMessageList({ pageSize: 5, pageNum: 1, systemId: 0 })
      if (data.code === 0) {
        store.state.messageList = (data.data && data.data.items) || []
      }
    },
    async getUnreadTotal(store) {
      const { data } = await getUnreadTotal()
      if (data.code === 0) {
        store.state.unread = (data.data && data.data.countUnread) || 0
      }
    },
  },
})

const openSocket = (url, systemId = 6) => {
  try {
    let headers = {}
    const token = Cookies.get('saasToken') && Cookies.get('saasToken').split('Bearer ')[1]
    // 没有token不连接socket
    if (!token) return
    // 建立链接
    const socket = new SockJS(
      `https:${url || '//test-newapi.shoplus.net'}/sock-js?system_id=${systemId}&token=${token}`
    )
    const client = Stomp.over(socket)
    client.connect(
      headers,
      () => {
        // 系统消息通道
        client.subscribe(`/user/topic/user-notification`, response => {
          Promise.all([store.dispatch('getMessageList'), store.dispatch('getUnreadTotal')])
        })
        // 系统公告通道
        client.subscribe(`/user/topic/system-notification`, response => {
          let obj = JSON.parse(response.body);
          window.eventBus.$emit('notice', obj)
          Promise.all([store.dispatch('getMessageList'), store.dispatch('getUnreadTotal')])
        })
      },
      () => {
        setTimeout(() => {
          console.log('断开重连，socket')
          openSocket(url)
        }, 60000)
      }
    )
  } catch (e) {
    console.error('错误为：', e)
  }
}
if (window.top == window) {
  openSocket(process.env.VUE_APP_SOCKET)
}
